<script>
import palette from '@inscribe/signal/dist/palette';
import { iIcon } from '@inscribe/signal';

// The ChartWrapper component provides basic "dumb" styling around charts.
// It renders a title and subtitle, if provided, and accepts a slot for the
// chart component itself. The chart component manages its own data; if it
// returns null or undefined, the ChartWrapper will render an empty state.

export default {
  name: 'ChartWrapper',
  components: {
    iIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return { palette };
  },
  computed: {
    isEmptyState() {
      return (
        !this.$slots.chart() ||
        !this.$slots.chart()[0].props.data ||
        this.$slots.chart()[0].props.data.length === 0
      );
    },
  },
};
</script>

<template>
  <div class="chart-wrapper d-flex flex-column i-radius-2xl">
    <div class="i-mb-12 d-flex flex-column">
      <div class="title i-text-neutral-120 i-text-button-2">{{ title }}</div>
      <div v-if="subtitle" class="subtitle i-text-neutral-110 i-text-body-2">
        {{ subtitle }}
      </div>
    </div>

    <!-- If the component passed to `chart` slot returns null or undefined, we'll render an empty state here -->
    <!-- That way the child component can handle its own data and this remains a "dumb" wrapper -->
    <div
      v-if="isEmptyState"
      class="empty_state d-flex flex-column align-items-center justify-content-center"
    >
      <i-icon
        symbol="large-file-text-search"
        class="icon i-text-neutral-80 i-mb-8"
        :size="46"
      ></i-icon>
      <div class="title i-text-neutral-110 i-text-button-3 i-mb-1">No data</div>
      <div class="description i-text-neutral-110 i-text-body-3">
        Try choosing different filters
      </div>
    </div>
    <div v-else class="chart d-flex flex-row align-items-center">
      <slot name="chart"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart-wrapper {
  border: 1px solid $light-neutral-60;
  width: 100%;
  padding: map.get($increments, 10);

  .empty_state {
    min-height: 200px;
  }

  .chart {
    height: 100%;
  }
}
</style>
